/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ViewLineupsPageErrorReportMutationVariables = {|
  greenMachineSessionID: string,
  error: string,
|};
export type ViewLineupsPageErrorReportMutationResponse = {|
  +reportGreenMachineError: ?{|
    +success: ?boolean
  |}
|};
export type ViewLineupsPageErrorReportMutation = {|
  variables: ViewLineupsPageErrorReportMutationVariables,
  response: ViewLineupsPageErrorReportMutationResponse,
|};
*/


/*
mutation ViewLineupsPageErrorReportMutation(
  $greenMachineSessionID: ID!
  $error: String!
) {
  reportGreenMachineError(input: {greenMachineSessionId: $greenMachineSessionID, error: $error}) {
    success
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "error"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "greenMachineSessionID"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "error",
            "variableName": "error"
          },
          {
            "kind": "Variable",
            "name": "greenMachineSessionId",
            "variableName": "greenMachineSessionID"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "ReportGreenMachineErrorPayload",
    "kind": "LinkedField",
    "name": "reportGreenMachineError",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ViewLineupsPageErrorReportMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ViewLineupsPageErrorReportMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "fe076c09c63698cfbb42b4cc17eb7af5",
    "id": null,
    "metadata": {},
    "name": "ViewLineupsPageErrorReportMutation",
    "operationKind": "mutation",
    "text": "mutation ViewLineupsPageErrorReportMutation(\n  $greenMachineSessionID: ID!\n  $error: String!\n) {\n  reportGreenMachineError(input: {greenMachineSessionId: $greenMachineSessionID, error: $error}) {\n    success\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '7381432e737919454b2f6b75b1dee711';

module.exports = node;
